import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  Button,
} from '@uncinc/uncinc-react-kitchen-sink';
import { ErrorPage } from '../../components';

const ServerError = () => {
  const { t } = useTranslation();

  return (
    <ErrorPage>
      <h1>{t('pages.500.title')}</h1>
      <p>{t('pages.500.body', { pagename: window.location.href })}</p>
      <Button
        primary
        className="icon-after icon-arrow icon-variant-1"
        onClick={() => {
          document.location.reload();
        }}
      >
        {t('pages.500.primary_button.link')}
      </Button>
    </ErrorPage>
  );
};

export default ServerError;
